import { isCookieAllowed } from './cookieConsent';

// Example analytics functions that respect cookie consent
export const initializeAnalytics = () => {
  if (isCookieAllowed('analytics')) {
    // This is where you would initialize Google Analytics or other analytics tools
    console.log('Analytics initialized');
    
    // Example code for Google Analytics (commented out)
    /*
    if (typeof window !== 'undefined') {
      // Load Google Analytics script
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.GOOGLE_ANALYTICS_ID}`;
      script.async = true;
      document.head.appendChild(script);
      
      // Initialize Google Analytics
      window.dataLayer = window.dataLayer || [];
      function gtag(...args: any[]) {
        window.dataLayer.push(args);
      }
      gtag('js', new Date());
      gtag('config', process.env.GOOGLE_ANALYTICS_ID);
    }
    */
  } else {
    console.log('Analytics not initialized due to cookie preferences');
  }
};

export const trackPageView = (path: string) => {
  if (isCookieAllowed('analytics')) {
    // This is where you would track a page view
    console.log(`Page view tracked: ${path}`);
    
    // Example code for Google Analytics (commented out)
    /*
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', process.env.GOOGLE_ANALYTICS_ID, {
        page_path: path,
      });
    }
    */
  }
};

export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  if (isCookieAllowed('analytics')) {
    // This is where you would track an event
    console.log(`Event tracked: ${category} / ${action} / ${label} / ${value}`);
    
    // Example code for Google Analytics (commented out)
    /*
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    }
    */
  }
};